'use client';

import dynamic from 'next/dynamic';
import { LoadingIndicator } from './LoadingIndicator';
import { WebAPIChartSlicerData } from '../../globals/webApiTypes/elements/WebAPICBS';
import { CBSStatlineDataset } from './cbsStatline.types';

const CbsGraphClientComponent = dynamic(() => import('./CbsGraph.client'), {
	loading: () => <LoadingIndicator />,
	ssr: false,
});

export function CbsGraphClientLoader({
	chartSlicerData,
	graphDataPromise,
}: {
	chartSlicerData: WebAPIChartSlicerData;
	graphDataPromise: Promise<CBSStatlineDataset>;
}) {
	return (
		<CbsGraphClientComponent
			chartSlicerData={chartSlicerData}
			graphDataPromise={graphDataPromise}
		/>
	);
}
